let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7EvFz")).then(() => parcelRequire('9IgL1'));